import { Event } from "@mcleod/components";
import { MenuActionSlideout } from "../MenuActionSlideout";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuEditorUtil } from "../MenuEditorUtil";
import { EditMenuItemResult, MenuItemEditor } from "../MenuItemEditor";
import { MenuAction } from "./MenuAction";
import { RowWebMenuGroupType } from "../../models/ModelWebMenuGroup";

export class MenuActionAddLeaf extends MenuAction {

    override async internalExecute(): Promise<boolean> {
        const parentNodes = this.getNodesMatchingThisMenuGroup();
        const result = await this.showSlideout(parentNodes);
        if (result == null)
            return false;

        const childMenuItem = this.menuDataSource.findAndReuseExistingMenuItemData(result.menuItem);
        childMenuItem.groupData.set("group_type", RowWebMenuGroupType.LEAF);
        for (const parentNode of parentNodes) {
            const newChild = childMenuItem.createCopy();
            this.menuItemToSelect ??= newChild;
            const parentBranch = parentNode.menuItem;
            parentBranch.addChild(newChild);
        }
        return true;
    }

    override validate(): boolean {
        return this.node?.hasChildren() === true;
    }

    private async showSlideout(parentNodes: MenuEditorTreeNode[]): Promise<EditMenuItemResult> {
        let layout: MenuItemEditor;
        const result = await MenuActionSlideout.showMenuItemEditorSlideout({
            title: this.getActionTitle("Add Menu Item"),
            layoutLoadListeners: [
                (event: Event) => {
                    layout = event.target as MenuItemEditor;
                    layout.configureForAddMode();
                    const msg = `${this.node.text} is a Shared Menu. This new menu item will be added to the following submenus:`;
                    MenuEditorUtil.addReferencePanel({text: msg, fontBold: true}, parentNodes, layout);
                }
            ]
        });
        return result ? layout.getEditMenuItemResult() : null;
    }
}
